import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SafetyControlSurveyNoteCategoriesDataGrid } from "src/components/views/erp/safetyControlSurvey/masterData/SafetyControlSurveyNoteCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/safetyControlSurvey/noteCategories")({
	staticData: {
		title: i18n.t("safety_control_survey_note_categories"),
		legacyViewKey: "safetyControlSurveyNoteCategoriesPage",
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <SafetyControlSurveyNoteCategoriesDataGrid />;
}
